import { useEffect, useState } from 'react';
import { RefreshCw, RotateCcw, XCircle } from 'lucide-react';
import { api } from '../lib/api';

type Failure={
  id:string;projectId:string;projectTitle:string;operation:string;targetType:string;targetId:string;
  errorText:string;retryCount:number;status:string;createdAt:string;lastRetryAt?:string|null;
};

const labels:Record<string,string>={
  ai_character_sheet:'Character model sheet',
  ai_page_art:'Page artwork',
  ai_panel_master:'Panel Print Master',
  ai_print_master:'300-DPI Print Master',
};

export default function RecoveryCenter({onClose}:{onClose:()=>void}){
  const[items,setItems]=useState<Failure[]>([]);
  const[busy,setBusy]=useState('');
  const[message,setMessage]=useState('');
  const load=async()=>setItems((await api.get<{items:Failure[]}>('/api/beta/recovery')).data.items);
  useEffect(()=>{load().catch(e=>setMessage(e instanceof Error?e.message:'Recovery items could not be loaded.'));},[]);
  return <div className="overlay"><div className="modal max-w-5xl">
    <div className="row items-start"><div><span className="eyebrow">RECOVERY CENTER</span><h2>Failed generations that can be safely retried.</h2><p className="muted">Retries use the project’s current saved state and consume credits only when the retry succeeds; failed AI calls are refunded by the existing credit guard.</p></div><button className="iconButton" onClick={onClose}>×</button></div>
    <button className="secondary mt-5" onClick={()=>load()}><RefreshCw size={14}/>Refresh</button>
    <div className="space-y-3 mt-4">{items.map(item=><article className="softBox" key={item.id}>
      <div className="row items-start"><div><b>{labels[item.operation]||item.operation}</b><div className="text-xs muted">{item.projectTitle} · {item.targetType} · {new Date(item.createdAt).toLocaleString()}</div></div><span className="status">retry {item.retryCount}</span></div>
      <p className="text-sm mt-3">{item.errorText}</p>
      <div className="flex gap-2 mt-3"><button className="primary" disabled={!!busy} onClick={async()=>{setBusy(item.id);setMessage('');try{await api.post(`/api/beta/recovery/${item.id}/retry`);setMessage('Retry completed.');await load()}catch(e){setMessage(e instanceof Error?e.message:'Retry failed.');await load()}finally{setBusy('')}}}><RotateCcw size={14}/>{busy===item.id?'Retrying…':'Retry now'}</button><button className="secondary" disabled={!!busy} onClick={async()=>{await api.post(`/api/beta/recovery/${item.id}/dismiss`);await load()}}><XCircle size={14}/>Dismiss</button></div>
    </article>)}</div>
    {!items.length&&<div className="empty mt-6"><CheckIcon/><b>No unresolved generation failures</b><p>New safe-to-retry failures will appear here automatically.</p></div>}
    {message&&<div className="hint mt-4">{message}</div>}
  </div></div>
}
function CheckIcon(){return <span className="text-3xl">✓</span>}
